/**
 * Keeps only the newest of several overlapping async loads. Call `begin()`
 * before each request; after the await, apply the response only when the
 * returned function still says `true`. A slower, older response then cannot
 * overwrite a newer one.
 */
export function createLatestGuard(): { begin: () => () => boolean } {
  let latest = 0;
  return {
    begin: () => {
      latest += 1;
      const mine = latest;
      return () => mine === latest;
    },
  };
}
